import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChange,
  ViewEncapsulation,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { IFlashCard } from 'src/app/interfaces/flashCardManagement';
import { FlashCardManagementService } from 'src/app/Services/flashcard-management.service';

@Component({
  selector: 'app-flashcard-list-modal',
  templateUrl: './flashcard-list-modal.component.html',
  styleUrls: ['./flashcard-list-modal.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class FlashcardListModalComponent implements OnInit  {
  @Input() SubjectId: number | null;
  @Input() ScreenName: string;
  @Input() editModalstate: string;
  @Output() openFlashCard = new EventEmitter<any>(); // Define EventEmitter

  FlashCards: IFlashCard[] = [];
  sortField: string = 'Display_Order';
  sortDirection: string = 'asc';
  filterText: string = '';
  path: string = '';
  constructor(
    public activeModal: NgbActiveModal,
    public flashcardService: FlashCardManagementService,
    private sanitizer: DomSanitizer,
    private readonly toaster: ToastrService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    const payloadGetquestions = {
      SubjectId: this.SubjectId,
      FlashcardID: null,
      ScreenName: this.ScreenName,
    };
    const pathPayload = {
      SubjectId: this.SubjectId,
      ScreenName: 'FLASHCARD',
    };
    forkJoin([
      this.flashcardService.getFlashCards$(payloadGetquestions),
      this.flashcardService.getPath$(pathPayload).pipe(
        catchError((err) => {
          return of('');
        })
      ),
    ]).subscribe(
      ([flashcard, path]) => {
        this.FlashCards = flashcard;
        this.path = path;
      },
      (error) => {
        // Handle errors gracefully
        console.error('Error fetching questions:', error);
        this.toaster.error('Failed to load questions. Please try again later.');
      }
    );

    this.flashcardService.nextButtonFlag$.subscribe((res)=>{
      this.refreshList()
    })
  }

  ngOnChanges(event: SimpleChange) {
    if (event) {
      console.log(event);
    }
  }
  get filteredFlashcards(): IFlashCard[] {
    // If no filter text, return sorted list directly
    if (!this.filterText) {
      return this.FlashCards.slice().sort((a, b) => this.sortByField(a, b));
    }

    const filterTextLower = this.filterText.toLowerCase();

    // Filter logic
    let result = this.FlashCards.filter((card) => {
      // Safely extract and normalize text for Front_Side_Text and Back_Side_Text
      const frontSidePlainText = card.Front_Side_Text
        ? this.stripHtml(card.Front_Side_Text).toLowerCase()
        : '';
      const backSidePlainText = card.Back_Side_Text
        ? this.stripHtml(card.Back_Side_Text).toLowerCase()
        : '';

      // Check specific fields with plain text
      const specificFieldsMatch =
        frontSidePlainText.includes(filterTextLower) ||
        backSidePlainText.includes(filterTextLower);
      if (specificFieldsMatch) {

      }
      //  else {
      //   console.log(frontSidePlainText, 'frontFalse');
      //   console.log(backSidePlainText, 'BackFalse');
      // }
      // // Check all string fields dynamically
      const generalFieldsMatch = Object.entries(card)
        .filter(([key, value]) => typeof value === 'string' && value !== null)
        .some(([key, value]) => value.toLowerCase().includes(filterTextLower));

      return specificFieldsMatch;
    });

    // Sort the filtered results
    return result.sort((a, b) => this.sortByField(a, b));
  }

  private sortByField(a: IFlashCard, b: IFlashCard): number {
    const fieldA = a[this.sortField as keyof IFlashCard];
    const fieldB = b[this.sortField as keyof IFlashCard];

    // Handle null or undefined values gracefully
    if (fieldA == null && fieldB == null) return 0;
    if (fieldA == null) return this.sortDirection === 'asc' ? -1 : 1;
    if (fieldB == null) return this.sortDirection === 'asc' ? 1 : -1;

    // Handle date fields specifically
    if (['Creation_Date', 'Updation_Date'].includes(this.sortField)) {
      const dateA = new Date(fieldA);
      const dateB = new Date(fieldB);
      return this.sortDirection === 'asc'
        ? dateA.getTime() - dateB.getTime()
        : dateB.getTime() - dateA.getTime();
    }

    // Default comparison for other fields
    return this.sortDirection === 'asc'
      ? fieldA.toString().localeCompare(fieldB.toString())
      : fieldB.toString().localeCompare(fieldA.toString());
  }

  private stripHtml(html: string): string {
    // Safely handle null or empty values
    if (!html) return '';
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || '';
  }

  SanitizeHTML(html: string) {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  triggerParentFunction(flashcard: IFlashCard): void {
    // Emit data to the parent component
    const data = {
      FlashCard_ID: flashcard.FlashCard_ID,
      type: 'list',
      FlashcardList: this.FlashCards,
    };
    this.openFlashCard.emit(data);
  }
  onCross() {
    this.activeModal.close(false);
  }

  refreshList() {
    const payloadGetquestions = {
      SubjectId: this.SubjectId,
      FlashcardID: null,
      ScreenName: this.ScreenName,
    };
    this.flashcardService
      .getFlashCards$(payloadGetquestions)
      .subscribe((flashcards) => {
        this.FlashCards = flashcards;
      });
  }

}
